// Google Maps API configuration (Geocoding + Places for resolving embed place IDs)
// Webpack must DefinePlugin this key: Expo does not inline REACT_APP_* on SDK 41+.
const GOOGLE_MAPS_API_KEY = (
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_GOOGLE_MAPS_API_KEY) ||
  (typeof process !== 'undefined' && process.env && process.env.EXPO_PUBLIC_GOOGLE_MAPS_API_KEY) ||
  'AIzaSyASBenU5xsQHtLAJFZe93bVUtdLj_Fq0to'
);

export { GOOGLE_MAPS_API_KEY };
